import React, {memo, useContext} from 'react';
import {withTranslation} from 'react-i18next';

import Duration from 'components/Duration';
import Flex, {Box} from 'components/Flex';
import TooltipButton from 'components/TooltipButton';

import ProgressBar from './ProgressBar';
import {ProgressContext} from '.';

/**
 * To prevent the main TransportBar component from updating
 * every time a frequently updated value changes, these values
 * are read from context instead of props:
 * - loaded
 * - played
 * - elapsedTime
 * - duration
 *
 * For the same reason, the context is being read in separate
 * components. The TransportBar component itself is only re-rendered
 * when its immediate props change (by using the React.memo helper).
 */

function ConnectedProgressBar(props) {
	const {loaded, played} = useContext(ProgressContext);
	return <ProgressBar loaded={loaded} played={played} {...props} />;
}

function ProgressReadout() {
	const {elapsedTime, duration} = useContext(ProgressContext);

	return (
		<>
			<Duration value={elapsedTime} role="timer" />
			/
			<Duration value={duration} role="timer" />
		</>
	);
}

function TransportBar(props) {
	const {isPlaying, isSeeking, onPlay, onSeek, t} = props;

	return (
		<Flex>
			<Box pr="xs">
				<TooltipButton
					icon={isPlaying ? 'pause' : 'play'}
					variant="transparent"
					onClick={onPlay}
					title={isPlaying ? t('actions_pause') : t('actions_play')}
				/>
			</Box>
			<Box grow shrink>
				<ConnectedProgressBar onClick={onSeek} isSeeking={isSeeking} />
			</Box>
			<Box pl="xs">
				<ProgressReadout />
			</Box>
		</Flex>
	);
}

export default withTranslation()(memo(TransportBar));
